/** Lowercased hashtag names on a feed activity (comment action). */
export function getActivityHashtagLoweredNames(activity) {
  const fromAction = activity?.action?.hashtags;
  if (Array.isArray(fromAction) && fromAction.length > 0) {
    return fromAction
      .map(h => (h?.loweredName || h?.name || '').toLowerCase())
      .filter(Boolean);
  }
  if (Array.isArray(activity?.hashtagLoweredNames)) {
    return activity.hashtagLoweredNames.map(n => String(n).toLowerCase()).filter(Boolean);
  }
  return [];
}

export function activityMatchesBoardHashtag(activity, boardHashtagName) {
  if (!boardHashtagName) return false;
  const tagNames = getActivityHashtagLoweredNames(activity);
  const target = String(boardHashtagName).toLowerCase();
  if (target === 'no_hashtag') {
    return tagNames.length === 0;
  }
  return tagNames.includes(target);
}

/** Matching activities first; relative order within each group preserved. */
export function sortActivitiesWithHashtagFirst(activities, boardHashtagName) {
  if (!boardHashtagName || !Array.isArray(activities)) return activities;
  const matching = [];
  const rest = [];
  for (const activity of activities) {
    if (activityMatchesBoardHashtag(activity, boardHashtagName)) {
      matching.push(activity);
    } else {
      rest.push(activity);
    }
  }
  return [...matching, ...rest];
}
